export const validateField = (values) => {
  let errors = {}
  if (!values.requestType) {
    errors.requestType = 'Required!'
  }
  if (!values.companyCode) {
    errors.companyCode = 'Required!'
  }
  if (!values.requestForType) {
    errors.requestForType = 'Required!'
  }
  if (!values.requestForCode) {
    errors.requestForCode = 'Required!'
  }
  if (!values.typeOfBond) {
    errors.typeOfBond = 'Required!'
  }else{
    if (values.typeOfBond=='other') {
      if (!values.typeOfBondOther) {
        errors.typeOfBondOther = 'Required!'
      }
    }
  }
  if (!values.amount) {
    errors.amount = 'Required!'
  }
  if (!values.startDate) {
    errors.startDate = 'Required!'
  }
  if (!values.isNoExpireDate) {
    if (!values.dueDate) {
      errors.dueDate = 'Required!'
    }
  }
  if (!values.expectReceivedDate) {
    errors.expectReceivedDate = 'Required!'
  }
  if (!values.referenceDocumentType) {
    errors.referenceDocumentType = 'Required!'
  }
  if(values.referenceDocumentType=='contract'){
    if (!values.referenceContractDate) {
      errors.referenceContractDate = 'Required!'
    }
    if (!values.bgc01||values.bgc01.length==0) {
      if(!values.attachments||!values.attachments.find(x=>x.documentCode=='BGC01'&&!x.deleted)){
        errors.bgc01 = 'Required!'
      }
    }
  }
  if(values.referenceDocumentType=='poNumber'){
    if (!values.referencePurchaseOrderNumber) {
      errors.referencePurchaseOrderNumber = 'Required!'
    }
    if (!values.bgc02||values.bgc02.length==0) {
      if(!values.attachments||!values.attachments.find(x=>x.documentCode=='BGC02'&&!x.deleted)){
        errors.bgc02 = 'Required!'
      }
    }
  }
  if (!values.title) {
    errors.title = 'Required!'
  }
  if (!values.requesterUser) {
    errors.requesterUser = 'Required!'
  }
  if (!values.projectManagerUser) {
    errors.projectManagerUser = 'Required!'
  }
  if(values.contacts){
    if(values.contacts.length>0){
      let filterContact = values.contacts.filter(x=>!x.firstName||!x.lastName||!x.email)
      if(filterContact.length>0){
        errors.contactsAlert = 'Required!'
      }
    }else{
      errors.contactsAlert = 'Required!'
    }
  }else{
    errors.contactsAlert = 'Required!'
  }
  if(!values.isContactValid){
    errors.contactsAlert = 'Contact email is not available!'
  }
  
  return errors
}

export const validateApproveField = (values) => {
  let errors = {}
  if(['Reject','Cancel'].indexOf(values.actionKey)>=0){
    if(!values.comment) {
      errors.comment = 'Required!'
    }
  }else{
    if (values.status==202) {// status Finance Processing
      if (!values.appointmentReceiveDate) {
        errors.appointmentReceiveDate = 'Required!'
      }
      if (!values.bgc03||values.bgc03.length==0) {
        errors.bgc03 = 'Required!'
      }
    }
    if (values.status==203) {// status Wait To Receive
      if (!values.receiveDate) {
        errors.receiveDate = 'Required!'
      }
    }
  }
  
  return errors
}